import NavBar from "framework/ui/content/NavBar";
import PageContent from "framework/ui/content/PageContent";
import PageTitle from "framework/ui/content/PageTitle";
import PageSections from "framework/ui/content/PageSections";
import Copyright from "framework/ui/content/Copyright";
import React from "react";
import './css/GuestBook.css'
import './css/NavBar.css'
import './css/PageContent.css'
import PageNavigation from "framework/ui/content/PageNavigation";
import Page from "framework/ui/content/Page";

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (<>
    <Page {...props}>
      <div className="TitleWrapper">
        <PageTitle alwaysShow={true}/>
      </div>
      <NavBar/>
      <PageContent>
        <PageSections/>
      </PageContent>
      <div className="PageFooter">
        <PageNavigation/>
        <Copyright startYear='2022'/>
      </div>
    </Page>
  </>);
}